import React, { useEffect, useState } from "react";
import "./IncidentList.scss";
import {
  GET_MDR_DASHBOARD_INCIDENT_LIST,
  SET_SELECTED_INCIDENT,
} from "../mdrConstants";
import { useDispatch, useSelector } from "react-redux";
import { generateColorMap } from "../MDRCommonComponents";

export default function IncidentList() {
  const dispatch = useDispatch();
  const incidents = useSelector(
    (state) => state.mdrReducer.mdrDashboardIncidentList
  );
  const selectedIncident = useSelector(
    (state) => state.mdrReducer.selectedIncident
  );

  const filteredIncidents = useSelector(
    (state) => state.mdrReducer.chartFilteredList
  );

  const displayIncidents =
    filteredIncidents && filteredIncidents.length > 0
      ? filteredIncidents
      : incidents;

  const [colorMap, setColorMap] = useState({});

  // Generate the color map based on available incident types
  useEffect(() => {
    const incidentTypes = [
      ...new Set(displayIncidents.map((item) => item.incidentType)),
    ];
    setColorMap(generateColorMap(incidentTypes));
  }, [displayIncidents]);

  const handleSelect = (incidentType) => {
    dispatch({ type: SET_SELECTED_INCIDENT, payload: incidentType });
  };

  return (
    <div className="incident-list">
      <h2 className="title">Incident Types</h2>
      <hr className="divider" />

      <div className="incident-scroll">
        {displayIncidents.map((item, idx) => {
          const isSelected = selectedIncident.includes(item.incidentType);
          return (
            <div
              className={`incident-item ${isSelected ? "selected" : ""}`}
              key={idx}
              onClick={() => handleSelect(item.incidentType)}
            >
              <div className="info">
                <div className="date" title="Latest Created Date">
                  {new Date(item.latestCreated).toLocaleString("en-US", {
                    month: "short",
                    day: "numeric",
                    hour: "numeric",
                    minute: "2-digit",
                    hour12: true,
                  })}
                </div>
              </div>
              <div className="incident-details">
                <div
                  className="count"
                  style={{
                    backgroundColor: colorMap[item.incidentType] || "#ccc",
                  }}
                >
                  {String(item.count).padStart(2, "0")}
                </div>
                <div>
                  <span className="label-Jira">{item.incidentType}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
